import { Backdrop, CircularProgress } from "@mui/material";

const Loader = ({ isLoading = false }) => {
  return (
    <Backdrop
      open={isLoading}
      sx={{ color: "secondary", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <CircularProgress color="secondary" />
    </Backdrop>
  );
};

export default Loader;
